// import { Link as LinkUsed } from 'gatsby';
import { Link as LinkUsed } from 'gatsby-plugin-intl';

export const Link = LinkUsed;

export default Link;
